module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center",
    staticStyle: {
      "padding": "100px 0px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding": "0px 5px 0px 10px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/crActivityInfoForm?rule_code=SA00001'
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-activity"
  }, [_c('span', {
    staticClass: "text-w-600"
  }, [_vm._v("贈送優惠券")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("消費金額滿額")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding": "0px 10px 0px 5px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/crActivityInfoForm?rule_code=SA00002'
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-activity"
  }, [_c('span', {
    staticClass: "text-w-600"
  }, [_vm._v("贈送優惠券")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("消費商品數量滿額")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "padding": "0px 10px 0px 5px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/crActivityInfoForm?rule_code=SA00003'
    }
  }, [_c('button', {
    staticClass: "btn btn-warning btn-activity"
  }, [_c('span', {
    staticClass: "text-w-600"
  }, [_vm._v("贈送優惠券")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("消費指定商品滿額")])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77d001f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/CrActivity.vue
// module id = 2485
// module chunks = 1